import { render, staticRenderFns } from "./AddInventoryConsumable.vue?vue&type=template&id=4c841c38"
import script from "./AddInventoryConsumable.vue?vue&type=script&lang=js"
export * from "./AddInventoryConsumable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports